import type { Raster } from '@repo/warp-engine';

/** straight RGBA 한 픽셀을 source-over 로 대상에 섞는다. 결과는 반올림한 8비트다. */
export const blendPixel = (
  dst: Uint8ClampedArray,
  offset: number,
  r: number,
  g: number,
  b: number,
  a: number,
): void => {
  if (a <= 0) return;
  const sa = a / 255;
  const da = (dst[offset + 3] ?? 0) / 255;
  const outA = sa + da * (1 - sa);
  if (outA <= 0) return;
  const blend = (s: number, d: number): number => Math.round((s * sa + d * da * (1 - sa)) / outA);
  dst[offset] = blend(r, dst[offset] ?? 0);
  dst[offset + 1] = blend(g, dst[offset + 1] ?? 0);
  dst[offset + 2] = blend(b, dst[offset + 2] ?? 0);
  dst[offset + 3] = Math.round(outA * 255);
};

/** src 를 dst 의 정수 위치 (x, y) 에 source-over 로 올린다. dst 밖은 자른다. */
export const compositeOver = (dst: Raster, src: Raster, x: number, y: number): void => {
  const x0 = Math.max(0, x);
  const y0 = Math.max(0, y);
  const x1 = Math.min(dst.width, x + src.width);
  const y1 = Math.min(dst.height, y + src.height);
  for (let dy = y0; dy < y1; dy += 1) {
    for (let dx = x0; dx < x1; dx += 1) {
      const s = ((dy - y) * src.width + (dx - x)) * 4;
      blendPixel(
        dst.data,
        (dy * dst.width + dx) * 4,
        src.data[s] ?? 0,
        src.data[s + 1] ?? 0,
        src.data[s + 2] ?? 0,
        src.data[s + 3] ?? 0,
      );
    }
  }
};
